export function validateCity(value) {
    const length = value.length;
    if( length < 1 ) {
        return {
            value : value,
            isValid : false,
            message : "Error: Please enter a City."
        }
    }
    else if (length > 30) {
        return {
            value : value,
            isValid : false,
            message : "Error: City cannot exceed 30 characters in length."
        } 
    }
    else if (length >= 1 && length <= 30) {
      // const LIMITED_TEXT_PATTERN = /^([\w-\.](\s)?)*$/; //Unnecessary escape character: \.
      const LIMITED_TEXT_PATTERN = /^([\w-.](\s)?)*$/;
      let matches = LIMITED_TEXT_PATTERN.test(value);
      if(!matches) {
        return {
            value : value,
            isValid : false,
            message : "Error: Please enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters."
        }
      } else {
        return {
            value : value,
            isValid : true,
            message : ""
        }
      }
   }
}

export default validateCity;


// WEBPACK FOOTER //
// ./src/helper/validateCity.js